import * as Sentry from '@sentry/nuxt'

/**
 * Centralized error handler that captures all errors and sends them to GlitchTip.
 * This eliminates the need to manually add Sentry.captureException() everywhere.
 */
export default defineNuxtPlugin((nuxtApp) => {
	// Hook into Vue errors (components, lifecycle, watchers, etc.)
	nuxtApp.hook('vue:error', (err, instance, info) => {
		Sentry.captureException(err, {
			level: 'error',
			tags: {
				errorSource: 'vue',
				errorInfo: info,
			},
			contexts: {
				vue: {
					componentName: instance?.$options?.name || 'Unknown',
					propsData: instance?.$props,
					lifecycleHook: info,
				},
			},
		})
		console.error('Vue error:', err, info)
	})

	// Hook into app errors (includes plugin errors, middleware errors, etc.)
	nuxtApp.hook('app:error', (err) => {
		Sentry.captureException(err, {
			level: 'fatal',
			tags: {
				errorSource: 'app',
			},
		})
		console.error('App error:', err)
	})

	// Capture unhandled promise rejections
	if (import.meta.client) {
		window.addEventListener('unhandledrejection', (event) => {
			Sentry.captureException(event.reason, {
				level: 'error',
				tags: {
					errorSource: 'unhandledRejection',
				},
			})
			console.error('Unhandled rejection:', event.reason)
		})

		// Capture global window errors
		window.addEventListener('error', (event) => {
			Sentry.captureException(event.error || event.message, {
				level: 'error',
				tags: {
					errorSource: 'window',
				},
			})
			console.error('Window error:', event.error || event.message)
		})
	}
})
